import React, { useImperativeHandle, useState } from "react";
import { observer } from "mobx-react";
import { Module, QueryKeys } from "../models/models";
import { Button, Grid, Group, Select, TextInput } from "@mantine/core";
import t from "../stores/language";
import Modal from "../custom-components/model";
import { useQuery, useStore } from "../stores/store";
import { useStyles } from "./app-container-components/configure-input";

export interface ModuleCreateHandle {
  show: (input: Module | null) => void;
}
export const defaultModule: Module = {
  id: 0,
  name: "",
  parentId: 0,
  metaData: "",
};
const ModuleCreator = observer(
  React.forwardRef<ModuleCreateHandle, unknown>(function ModuleCreator(props, ref) {
    const { classes } = useStyles();
    const { store } = useStore();
    const [duplicateName, setDuplicateName] = useState<string | null>();
    const { data: modules } = useQuery({
      queryKey: [QueryKeys.Modules],
      queryFn: async () => {
        return await store.GetAllModules();
      },
    });
    const [visible, setVisible] = useState<boolean>(false);
    useImperativeHandle(ref, () => {
      return {
        show: show,
      };
    });
    const show = (input: Module | null) => {
      setModule(input ?? defaultModule);
      setVisible(true);
    };

    const [module, setModule] = useState<Module>(defaultModule);
    const resetState = () => {
      setModule({ id: 0, name: "", parentId: 0 });
    };
    const addModule = () => {
      if (module.id === 0) {
        if (store.modules.find((d) => d.name == module.name) != null) {
          setDuplicateName(`Module with name ${module.name} already exists`);
          return;
        }
        store.AddModule({ ...module, id: modules?.length ?? 0 + 1 });
      } else {
        store.UpdateModule({ ...module });
      }
      resetState();
      setVisible(false);
    };

    return (
      <>
        <Modal
          opened={visible}
          header={module.id === 0 ? t("Add Module") : t(`Update ${module.name}`)}
          footer={
            <Group className={classes.modalFooter}>
              <Button
                variant={"default"}
                onClick={() => {
                  setVisible(false);
                }}
              >
                {t("Cancel")}
              </Button>
              <Button onClick={() => addModule()}>{module.id === 0 ? t("Add") : t("Update")}</Button>
            </Group>
          }
          withCloseButton={true}
          onClose={() => {
            setVisible(false);
          }}
          size={"50%"}
        >
          <Grid pb={15} pl={15} pr={15} columns={12} m={0}>
            <Grid.Col span={6}>
              <TextInput
                error={duplicateName}
                label={t("Name")}
                radius={0}
                value={module.name}
                onChange={(e) => {
                  setModule({ ...module, name: e.target.value });
                  setDuplicateName(null);
                }}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <Select
                label={t("Parent")}
                searchable
                withinPortal
                nothingFound={t("No module found")}
                maxDropdownHeight={150}
                data={(modules ?? []).map((d) => d.name)}
                value={modules?.find((d) => d.id === module.parentId)?.name ?? null}
                onChange={(v) => {
                  setModule({ ...module, parentId: modules?.find((d) => d.name === v)?.id ?? 0 });
                }}
              ></Select>
            </Grid.Col>
          </Grid>
        </Modal>
      </>
    );
  })
);
export default ModuleCreator;
